import { principles, sourceLevels } from '@/mocks/site';

export default function PrinciplesSection() {
  return (
    <>
      <section id="principles" className="w-full bg-background-50 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-2xl">
            <p className="font-label text-xs tracking-[0.25em] text-primary-600 mb-3">
              OUR PRINCIPLES / 内容原则
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
              我们给自己定的四条底线
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              做真实事件对照，最容易犯的错就是「为了结论好看而放宽标准」。以下四条是我们在每条档案里都会遵守的原则，也欢迎读者据此监督。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
            {principles.map((item) => (
              <div
                key={item.title}
                className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 hover:border-accent-300 transition-colors"
              >
                <div className="flex items-start gap-4">
                  <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="sources" className="w-full bg-foreground-950 py-14 md:py-20">
        <div className="w-full px-4 md:px-8">
          <div className="max-w-2xl">
            <p className="font-label text-xs tracking-[0.25em] text-accent-400 mb-3">
              SOURCE LEVELS / 信源分级
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
              什么样的信息，才够格写进档案
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-300/85 leading-relaxed">
              不是所有「爆料」都能作为依据。我们把信息来源分成四级，级别越低，能进入结论的程度就越低。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-background-50/10 rounded-lg overflow-hidden">
            {sourceLevels.map((item) => (
              <div key={item.level} className="bg-foreground-950 p-5 md:p-6">
                <span className="inline-block px-2.5 py-1 rounded-md bg-accent-500 text-primary-950 font-label text-xs">
                  {item.level}
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-background-50 leading-snug">
                  {item.type}
                </h3>
                <p className="mt-3 text-xs md:text-sm text-background-300/80 leading-relaxed">
                  {item.usage}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}